<template>
  <div class="files-list">
    <v-row v-if="files.length">
      <v-col
        v-for="file in files"
        :key="file.id"
        class="py-2"
        cols="12"
        md="6"
      >
        <AppFile
          :file="file"
          selectable
          :selected-files="value"
          @select="selectFile"
        />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <AppEmptyState
          class="my-4"
          title="Brak plików"
          subtitle="Nie zostały dodane jeszcze żadne pliki o wybranym statusie."
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppFile from '@/components/UI/AppFile.vue';
import AppEmptyState from '@/components/UI/AppEmptyState.vue';

export default {
  components: {
    AppFile,
    AppEmptyState,
  },

  props: {
    files: {
      type: Array,
      required: true,
    },
    value: { // selected files
      type: Array,
      default: () => [],
    },
  },

  methods: {
    selectFile(fileId) {
      let selectedFiles = [...this.value];
      if (selectedFiles.includes(fileId)) {
        selectedFiles = selectedFiles.filter((id) => id !== fileId);
      } else {
        selectedFiles.push(fileId);
      }
      this.$emit('input', selectedFiles);
    },
  },
};
</script>
